export class DataComponentBaseModel {
    public idDataSet: number;
    public primaryColumn: string;
    public secondaryColumn: string;
    public datetimeInclusion: Date;
}
export class DataComponentModel extends DataComponentBaseModel {
    public idDataProduct: number;
    public idDataComponent: number;
}